import React, { useEffect, useRef, useState } from "react"
import styles from "./Chat.module.scss"
import pretzelIcon from "./logo-square.png"
import axios from "axios"
import Files from "./Files/Files"
import { UserInterface } from "../../../App"
import { API_ROUTE } from "../../../utils"
import FlashCards from "./FlashCards/FlashCards"

const Chat: React.FC<{
    appSpaces: any
    setActiveAppSpace: any
    newAppSpace: any
    rawContext: string
    activeSession: any
    setUser: any
    user: UserInterface
    send?: string
    createFile: string
}> = ({
    appSpaces,
    rawContext,
    setActiveAppSpace,
    newAppSpace,
    activeSession,
    setUser,
    user,
    send,
    createFile,
}) => {
    const formatCurrentTime = () => {
        const date = new Date()
        const hours = date.getHours()
        const minutes = date.getMinutes()
        const ampm = hours >= 12 ? "PM" : "AM"
        const formattedHours = hours % 12 || 12
        const formattedMinutes = minutes < 10 ? "0" + minutes : minutes
        const currentTime = `${formattedHours}:${formattedMinutes} ${ampm}`
        return currentTime
    }

    const messagesContainer = useRef<HTMLDivElement>(null)
    const [messages, setMessages] = useState<any>({})
    const [pretzelTyping, setPretzelTyping] = useState(false)
    const [flashcardsData, setFlashcardsData] = useState("")

    const scrollToBottom = () => {
        if (messagesContainer.current) {
            messagesContainer.current.scrollTop = messagesContainer.current.scrollHeight
        }
    }

    const sendMessage = async (text: string) => {
        setMessages((prevMessages: any) => {
            return {
                ...prevMessages,
                [Date.now()]: {
                    name: user?.name || "Guest",
                    time: formatCurrentTime(),
                    text: text,
                },
            }
        })
        setTimeout(scrollToBottom, 150)

        if (text === "files") return

        try {
            setPretzelTyping(true)
            const cmd = text.toLocaleLowerCase().replaceAll(" ", "")

            const getPrompt = () => {
                if (cmd === "flashcards")
                    return `Create flashcards based on the user's active document. Format flashcards as follows to be parsed by my server:
                    <item>Q: Question 1 / A: Answer 1</item><item>Q: Question 2 / A: Answer 2</item><item>Q: Question 3 / A: Answer 3</item>`

                if (appSpaces?.length > 0)
                    return `Respond to the users query, based on their document contents provided as context. User: ${text}`
                else return text
            }

            const response = await axios.post(`${API_ROUTE}/gpt`, {
                fileId:
                    cmd === "flashcards"
                        ? Date.now()
                        : activeSession.fileId || user.authToken || navigator.userAgent,
                query: getPrompt(),
                context: rawContext.slice(0, 4000).replace(/(<([^>]+)>)/gi, ""),
            })

            if (response.data.includes("<item>")) setFlashcardsData(response.data)
            setPretzelTyping(false)

            if (cmd === "flashcards") return
            setMessages((prevMessages: any) => {
                return {
                    ...prevMessages,
                    [Date.now()]: {
                        name: "Pretzel",
                        time: formatCurrentTime(),
                        text: response.data,
                    },
                }
            })
            setTimeout(scrollToBottom, 150)
        } catch (error) {
            console.error("Error sending message:", error)
        }
    }

    useEffect(() => {
        if (send) {
            sendMessage(send)
            // eslint-disable-next-line react-hooks/exhaustive-deps
            send = undefined
        }
    }, [send])

    return (
        <div className={styles.Chat}>
            <div ref={messagesContainer} className={styles.container}>
                <div className={styles.messages}>
                    {Object.keys(messages).map((key: any, index: number) => {
                        return (
                            <div
                                key={index}
                                style={{
                                    background:
                                        messages[key].name === "Pretzel" ? undefined : "#E8F0FE50",
                                }}
                                className={styles.message}>
                                {messages[key].name === "Pretzel" ? (
                                    <img src={pretzelIcon} width={40} height={40} alt="icon" />
                                ) : (
                                    <div className={styles.profile}>
                                        {messages[key].name?.slice(0, 2)}
                                    </div>
                                )}

                                <div>
                                    <div className="flex">
                                        <p className={styles.name}>{messages[key].name}</p>
                                        <p className={styles.time}>{messages[key].time}</p>
                                    </div>
                                    {messages[key].text === "files" && (
                                        <Files
                                            newAppSpace={newAppSpace}
                                            setActiveAppSpace={setActiveAppSpace}
                                            setUser={setUser}
                                            user={user}
                                            createFile={createFile}
                                        />
                                    )}
                                    {messages[key].text === "flashcards" && (
                                        <FlashCards message={flashcardsData} />
                                    )}

                                    {messages[key].text !== "files" &&
                                        messages[key].text !== "flashcards" && (
                                            <>
                                                {messages[key].name === "Pretzel" ? (
                                                    <p
                                                        dangerouslySetInnerHTML={{
                                                            __html: messages[key].text.replace(
                                                                /(?:\r\n|\r|\n)/g,
                                                                "<br>"
                                                            ),
                                                        }}></p>
                                                ) : (
                                                    <div className={styles.text}>
                                                        {messages[key].text}
                                                    </div>
                                                )}
                                            </>
                                        )}
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>

            <div className={styles.send}>
                <input
                    type="text"
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            sendMessage(e.currentTarget.value)
                            e.currentTarget.value = ""
                        }
                    }}
                    className={styles.input}
                    placeholder="Web/file search  |  Command  |  Chat with Pretzel"
                />
                <div>
                    <i className="material-symbols-rounded">send</i>
                </div>
            </div>

            <div className={styles.tray}>
                {appSpaces?.length > 0 && (
                    <div className={styles.demo}>
                        <span onClick={() => sendMessage("files")}>Files</span>
                        <span onClick={() => sendMessage("flashcards")}>Flashcards</span>
                        <span onClick={() => sendMessage("summarize")}>Summarize</span>
                    </div>
                )}
                <div style={{ opacity: pretzelTyping ? 1 : 0 }} className={styles.pretzelTyping}>
                    <div style={{ scale: "0.7" }} className="loader"></div>
                    <p>Pretzel is typing...</p>
                </div>
            </div>
        </div>
    )
}

export default Chat
